export const macQwertyGB = {
  name: 'Mac QWERTY GB',
  platform: 'Mac',
  layout: 'QWERTY',
  region: 'GB',

  clashes: {
    MetaLeft: [
      'KeyA', // Select All
      'KeyB', // Bold
      'KeyC', // Copy
      'KeyF', // Find
      'KeyG', // Find Next
      'KeyH', // Replace
      'KeyI', // Italic
      'KeyM', // Minimize
      'KeyN', // New
      'KeyO', // Open
      'KeyP', // Print
      'KeyQ', // Quit
      'KeyR', // Reload
      'KeyS', // Save
      'KeyT', // New Tab
      'KeyV', // Paste
      'KeyW', // Close
      'KeyX', // Cut
      'KeyY', // Redo
      'KeyZ', // Undo
      'BracketLeft', // Navigate Back
      'BracketRight', // Navigate Forward
      'Comma', // Preferences
      'Minus', // Zoom Out
      'Equal', // Zoom In
    ],
    MetaRight: [
      'KeyA', 'KeyB', 'KeyC', 'KeyF', 'KeyG', 'KeyH', 'KeyI', 'KeyM', 'KeyN',
      'KeyO', 'KeyP', 'KeyQ', 'KeyR', 'KeyS', 'KeyT', 'KeyV', 'KeyW', 'KeyX',
      'KeyY', 'KeyZ', 'BracketLeft', 'BracketRight', 'Comma', 'Minus', 'Equal'
    ],
    AltLeft: [
      'KeyA', // å
      'KeyE', // é
      'KeyI', // î
      'KeyN', // ñ
      'KeyO', // ø
      'KeyU', // ü
      'Digit3', // #
      'BracketLeft', // "
      'BracketRight', // '
    ],
    AltRight: [
      'KeyA', 'KeyE', 'KeyI', 'KeyN', 'KeyO', 'KeyU',
      'Digit3', 'BracketLeft', 'BracketRight'
    ],
    ShiftLeft: [],
    ShiftRight: [],
    ControlLeft: [
      'KeyA', // Move to Start of Line
      'KeyE', // Move to End of Line
      'KeyK', // Delete to End of Line
      'Space', // Page Down
    ],
    ControlRight: [
      'KeyA', 'KeyE', 'KeyK', 'Space'
    ],
    'MetaLeft+AltLeft': [
      'KeyC', // Copy Style
      'KeyV', // Paste Style
      'KeyF', // Full Screen
      'KeyM', // Move to Dock
      'KeyB', // Emoji Picker
      'Space', // Spotlight Search
    ],
    'MetaRight+AltRight': [
      'KeyC', 'KeyV', 'KeyF', 'KeyM', 'KeyB', 'Space'
    ]
  },

  keys: [
    {
      row: 0,
      keys: [
        { id: 'Escape', display: 'esc', className: 'long' },
        { id: 'F1', display: 'F1' },
        { id: 'F2', display: 'F2' },
        { id: 'F3', display: 'F3' },
        { id: 'F4', display: 'F4' },
        { id: 'F5', display: 'F5' },
        { id: 'F6', display: 'F6' },
        { id: 'F7', display: 'F7' },
        { id: 'F8', display: 'F8' },
        { id: 'F9', display: 'F9' },
        { id: 'F10', display: 'F10' },
        { id: 'F11', display: 'F11' },
        { id: 'F12', display: 'F12' },
      ]
    },
    {
      row: 1,
      keys: [
        { id: 'Digit1', display: '1', shifted: '!' },
        { id: 'Digit2', display: '2', shifted: '@' },
        { id: 'Digit3', display: '3', shifted: '£', }, //Add Alt combo
        { id: 'Digit4', display: '4', shifted: '$' },
        { id: 'Digit5', display: '5', shifted: '%' },
        { id: 'Digit6', display: '6', shifted: '^' },
        { id: 'Digit7', display: '7', shifted: '&' },
        { id: 'Digit8', display: '8', shifted: '*' },
        { id: 'Digit9', display: '9', shifted: '(' },
        { id: 'Digit0', display: '0', shifted: ')' },
        { id: 'Minus', display: '-', shifted: '_' },
        { id: 'Equal', display: '=', shifted: '+' },
        { id: 'Backspace', display: 'delete', className: 'long' }
      ]
    },
    {
      row: 2,
      keys: [
        { id: 'Tab', display: 'tab', className: 'long' },
        { id: 'KeyQ', display: 'Q' },
        { id: 'KeyW', display: 'W' },
        { id: 'KeyE', display: 'E' },
        { id: 'KeyR', display: 'R' },
        { id: 'KeyT', display: 'T' },
        { id: 'KeyY', display: 'Y' },
        { id: 'KeyU', display: 'U' },
        { id: 'KeyI', display: 'I' },
        { id: 'KeyO', display: 'O' },
        { id: 'KeyP', display: 'P' },
        { id: 'BracketLeft', display: '[', shifted: '{' },
        { id: 'BracketRight', display: ']', shifted: '}' },
        { id: 'Enter', display: 'return', className: 'long' }
      ]
    },
    {
      row: 3,
      keys: [
        { id: 'CapsLock', display: 'caps lock', className: 'long' },
        { id: 'KeyA', display: 'A' },
        { id: 'KeyS', display: 'S' },
        { id: 'KeyD', display: 'D' },
        { id: 'KeyF', display: 'F' },
        { id: 'KeyG', display: 'G' },
        { id: 'KeyH', display: 'H' },
        { id: 'KeyJ', display: 'J' },
        { id: 'KeyK', display: 'K' },
        { id: 'KeyL', display: 'L' },
        { id: 'Semicolon', display: ';', shifted: ':' },
        { id: 'Quote', display: "'", shifted: '"' },
        { id: 'Backslash', display: '\\', shifted: '|' },
      ]
    },
    {
      row: 4,
      keys: [
        { id: 'ShiftLeft', display: 'shift', className: 'long modifier' },
        { id: 'Backquote', display: '`', shifted: '~' },
        // { id: 'IntlBackslash', display: '\\', shifted: '|' },
        { id: 'KeyZ', display: 'Z' },
        { id: 'KeyX', display: 'X' },
        { id: 'KeyC', display: 'C' },
        { id: 'KeyV', display: 'V' },
        { id: 'KeyB', display: 'B' },
        { id: 'KeyN', display: 'N' },
        { id: 'KeyM', display: 'M' },
        { id: 'Comma', display: ',', shifted: '<' },
        { id: 'Period', display: '.', shifted: '>' },
        { id: 'Slash', display: '/', shifted: '?' },
        { id: 'ShiftRight', display: 'shift', className: 'long modifier' }
      ]
    },
    {
      row: 5,
      keys: [
        { id: 'ControlLeft', display: 'ctrl', className: 'modifier' },
        { id: 'AltLeft', display: 'opt', className: 'modifier' },
        { id: 'MetaLeft', display: '⌘', className: 'modifier' },
        { id: 'Space', display: '', className: 'long space' },
        { id: 'MetaRight', display: '⌘', className: 'modifier' },
        { id: 'AltRight', display: 'opt', className: 'modifier' },
        { id: 'ControlRight', display: 'ctrl', className: 'modifier' }
      ]
    }
  ]
};
